import ImageComponent from "../shared/ImageComponent";
import NoProfile from "../../../images/profileImage.png";
import {useEffect, useRef, useState} from "react";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import {interventionDate} from "../../../utils/date";
import LightGallery from "lightgallery/react";
import {fileFormat} from "../../../utils/constants";
import "./proposalStyle.css";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import {Dropdown} from "react-bootstrap";
import DropdownToggle from "react-bootstrap/esm/DropdownToggle";
import {useChatRoom} from "../../../hooks/useChat";
import CertainModal from "../shared/CertainModal";
import {protectedAxiosInstance} from "../../../services/AxiosInstance";
import {getChatMessageLayout} from "../../../utils/chatMessageLayout";

const SecureChatAttachment = ({attachment, onLoad}) => {
  const [objectUrl, setObjectUrl] = useState("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    protectedAxiosInstance
      .get(`/api/chatmessage/attachment/${attachment.id}`, {
        responseType: "blob",
      })
      .then(({data}) => {
        if (!active) return;
        setObjectUrl(URL.createObjectURL(data));
      })
      .catch(() => active && setFailed(true));

    return () => {
      active = false;
    };
  }, [attachment.id]);

  useEffect(
    () => () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    },
    [objectUrl],
  );

  if (failed) {
    return <span className="text-red-600">Pièce jointe indisponible</span>;
  }
  if (!objectUrl) {
    return <span className="text-[#7e7e7e]">Chargement du fichier…</span>;
  }

  const downloadName = attachment.name || attachment.path?.split("/").pop() || "fichier";
  if (attachment.format === fileFormat.PDF) {
    return (
      <div className="flex items-center gap-2 p-2 bg-gray-100 rounded">
        <i className="fi fi-sr-document"></i>
        <span className="truncate">{downloadName}</span>
        <a
          href={objectUrl}
          download={downloadName}
          className="text-[#1A64B9] cursor-pointer"
        >
          <i className="fi fi-sr-down-to-line"></i>
        </a>
      </div>
    );
  }
  if (attachment.format === fileFormat.VIDEO) {
    return (
      <video
        onLoadedData={onLoad}
        className="w-[95%] aspect-video"
        src={objectUrl}
        controls
      />
    );
  }
  return (
    <LightGallery>
      <a href={objectUrl}>
        <img
          onLoad={onLoad}
          className="w-[95%] aspect-square object-cover"
          src={objectUrl}
          alt={downloadName}
        />
      </a>
    </LightGallery>
  );
};

const ChatMessages = ({conversation, messages, user, loading}) => {
  const messagesEndRef = useRef(null); // Ref to track the bottom of the messages

  const handelScroll = () => {
    const div = messagesEndRef.current;
    if (div) {
      div.scrollTop = div.scrollHeight;
    }
  };

  // Scroll to the bottom whenever messages change
  useEffect(() => {
    // if (messagesEndRef.current) {

    //   // messagesEndRef.current.scrollIntoView({behavior: "smooth"});
    // }
    handelScroll();
  }, [messages]);

  return (
    <div
      ref={messagesEndRef}
      className="flex-grow p-4 overflow-y-auto bg-white"
    >
      {messages.map((message) => (
        <MessageComponent
          key={message._id || message.id}
          message={message}
          user={user}
          handelScroll={handelScroll}
        />
      ))}
      {loading && (
        <div
          className="flex gap-3 items-start w-full justify-start flex-row-reverse"
        >
          <ImageComponent
            alt=""
            src={buildImageUrl(user?.imageUri)}
            className="w-8 aspect-square rounded-full object-cover"
            fallback={
              <img
                alt=""
                className="w-8 aspect-square rounded-full object-cover"
                src={NoProfile}
              />
            }
          />
          <div
            className={`mt-4 p-3 font-medium flex flex-col gap-2 text-left text-[15px] leading-6 text-[#2F2F2F] max-w-[400px] bg-[#F4F4F4] rounded-tl-xl rounded-b-xl `}
          >
            <div className="flex items-center justify-center h-20 aspect-square">
              <div className="w-10 h-10 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
            </div>
          </div>
        </div>
      )}
      {/* Invisible div to keep track of the bottom */}
      {/* <div ref={messagesEndRef} className="bg-black w-4 h-1 mt-32" /> */}
    </div>
  );
};

export default ChatMessages;

const MessageComponent = ({message, user, handelScroll}) => {
  const {onDeleteMessage} = useChatRoom();
  const [openModal, setOpenModal] = useState(false);
  const messageLayout = getChatMessageLayout(message.userId, user.id);

  return (
    <div
      key={message.id}
      className={`flex gap-3 items-start w-full justify-start ${messageLayout.rowClassName}`}
    >
      <CertainModal
        setShow={setOpenModal}
        show={openModal}
        title={"Suppression du message"}
        message={
          "Votre message sera supprimé pour tous le monde. Vous voulez continuer?"
        }
        buttonTitle={"Oui"}
        handelButton={() => {
          onDeleteMessage({messageId: message?.id});
          setOpenModal(false);
        }}
        secondButtonTitle={"Non"}
      />
      <ImageComponent
        alt=""
        src={buildImageUrl(
          message?.User?.imageUri ||
            (messageLayout.isOwn ? user?.imageUri : null),
        )}
        className="w-8 aspect-square rounded-full object-cover"
        fallback={
          <img
            alt=""
            className="w-8 aspect-square rounded-full object-cover"
            src={NoProfile}
          />
        }
      />

      <div
        className={`mt-4 p-3 pr-4 font-medium flex flex-col relative gap-2 text-left text-[15px] leading-6 text-[#2F2F2F] max-w-[400px] cursor-pointer ${
          messageLayout.bubbleClassName
        } ${
          message?.deletedAt
            ? "bg-[#fff] border border-[#F4F4F4] !text-[#7e7e7e] !font-light !text-[13px] italic "
            : ""
        } `}
      >
        {!message?.deletedAt ? (
          <>
            {messageLayout.isOwn && (
              <div className="absolute top-3 right-1 w-fit">
                <Dropdown className="">
                  <DropdownToggle
                    variant=""
                    className=" i-false !p-0  text-[#7e7e7e] !text-xs cursor-pointer"
                  >
                    <i className="fi fi-rr-menu-dots-vertical flex items-center"></i>
                  </DropdownToggle>
                  <DropdownMenu
                    align="right"
                    className=" p-0 !rounded-md !min-w-5 !w-fit"
                  >
                    <Dropdown.Item
                      className="cursor-pointer group !px-2  font-semibold hover:bg-[#EFF2F7] !text-[#3D4465] hover:!text-[#3D4465] !text-xs"
                      onClick={() => setOpenModal(true)}
                    >
                      Supprimer
                    </Dropdown.Item>
                  </DropdownMenu>
                </Dropdown>
              </div>
            )}
            {!!message?.FileUploads?.length && message.FileUploads[0].format && (
              <SecureChatAttachment
                attachment={message.FileUploads[0]}
                onLoad={handelScroll}
              />
            )}
            <div className="w-full">{message.text}</div>
            <div className="w-full text-[10px] text-[#7e7e7e]">
              {interventionDate(message.createdAt)}
            </div>
          </>
        ) : (
          <div>Message supprimé</div>
        )}
      </div>
    </div>
  );
};
